import { Company } from '@/services/fintalk/services/fintalk-backoffice/companies/list'
import { StringSizeFormatter } from '@/utils/formatters/string'
import { randomPattern } from '@/utils/randoms'

import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar'

export function CompanyDisplay({ company }: { company: Company }) {
  return (
    <div className="flex items-center gap-2">
      <Avatar className="h-9 w-9">
        <AvatarImage
          src={company.picture}
          alt={company.name}
          className="object-cover"
        />
        <AvatarFallback>{randomPattern('avatar', company.name)}</AvatarFallback>
      </Avatar>

      {StringSizeFormatter(company.name, 12)}
    </div>
  )
}
